var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'coze': _vm.iscoze},attrs:{"id":"app"}},[_c('div',{staticClass:"bgs"},[_c('div',{staticClass:"appmains"},[_c('HeaderComponent'),_vm._v(" "),_c('el-container',[(_vm.iscoze)?_c('el-aside',{staticClass:"sidebar"}):_vm._e(),_vm._v(" "),_c('el-main',[_c('router-view')],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-765b798a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 